import template from './checklistItemList.template.html';

export default {
  template,
  bindings: {
    checklistItem: '=',
    onEdit: '&',
    onDelete: '&',
    onToggle: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.checklistItem = ctrl.checklistItem || {};
      };

      ctrl.checklistItemEdit = ($event) => {
        ctrl.onEdit({ event: $event, data: ctrl.checklistItem });
      };

      ctrl.checklistItemDelete = ($event) => {
        ctrl.onDelete({ event: $event, data: ctrl.checklistItem });
      };

      ctrl.checklistItemToggle = ($event) => {
        ctrl.checklistItem.isCompleted = !ctrl.checklistItem.isCompleted;
        if (ctrl.checklistItem.isCompleted) {
          ctrl.checklistItem.isPartial = false;
          ctrl.checklistItem.isDue = false;
          ctrl.checklistItem.isOverdue = false;
        } else {
          const todayDate = moment.utc().startOf('day');
          const isOverdue = moment
            .utc(ctrl.checklistItem.timeStamp, 'X')
            .add(ctrl.checklistItem.due, 'days')
            .isBefore(todayDate, 'day');
          if (isOverdue) {
            ctrl.checklistItem.isDue = true;
            ctrl.checklistItem.isOverdue = true;
          } else {
            const isDue = moment
              .utc(ctrl.checklistItem.timeStamp, 'X')
              .add(ctrl.checklistItem.due, 'days')
              .isSame(todayDate, 'day');
            if (isDue) {
              ctrl.checklistItem.isDue = true;
              ctrl.checklistItem.isOverdue = false;
            }
          }
          ctrl.checklistItem.isPartial = !ctrl.checklistItem.isPartial;
        }
        ctrl.onToggle({ event: $event, data: ctrl.checklistItem });
      };

      ctrl.select = () => {
        ctrl.onChange({ data: ctrl.checklistItem });
      };

      ctrl.getAccount = (idAccount) =>
        _.find(ctrl.accounts, (account) => account.id === idAccount);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.checklistItems && changes.checklistItems.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
